var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 328.2 39.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05E4\\u05E2\\u05D9\\u05DC\\u05D5\\u05EA_\\u05E6\\u05D9\\u05D1\\u05D5\\u05E8\\u05D9\\u05EA",
    "data-name": "\\u05E4\\u05E2\\u05D9\\u05DC\\u05D5\\u05EA \\u05E6\\u05D9\\u05D1\\u05D5\\u05E8\\u05D9\\u05EA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.29,12.36h-7.28v20.07H0v-8.13h4.79v-11.94H1.41V4.23h29.09v28.2h-9.21V12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.31,12.36h-13.02V4.23h22.23v28.2h-9.21V12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.31,4.23h9.21v28.2h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.04,4.23v13.77c0,9.68-6.25,15.37-16.97,15.37s-16.97-5.69-16.97-15.37V4.23h9.07v7h3.57v-7h8.65v14.9h-12.17c.47,3.76,3.29,5.78,7.85,5.78,4.98,0,7.9-2.44,7.9-6.91V4.23h9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.78,4.23l-10.39,28.81-8.55-3.34,6.3-17.34h-16.78V4.23h29.42ZM117.36,17.06h9.21v22.42h-9.21v-22.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.04,12.36h-7.28v20.07h-14.01v-8.13h4.79v-11.94h-3.38V4.23h29.09v28.2h-9.21V12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.48,32.43h-24.86v-8.13h11.61v-11.94h-11.61V4.23h20.82v20.07h4.04v8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.54,4.23h9.21v28.2h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.74,24.3V4.23h9.16l.05,28.2h-16.45v-8.13h7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.49,4.23h9.21v15.51h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.22,0h9.21v4.23h15.79l-12.17,29.14-8.41-3.43,7.43-17.58h-11.84V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.2,4.23v28.2h-27.87v-8.13h4.89V4.23h9.21v20.07h4.56V4.23h9.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/עלינו בתקשורתmdpi.e90d2c22dcf2414c5ce60259d1225966.svg";
export { ForwardRef as ReactComponent };